import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import Portfolio from './components/Portfolio';
import Loader from './components/Loader';

const THEME_KEY = 'pzt:darkMode';
const LANGUAGE_KEY = 'pzt:language';
const BOOTED_KEY = 'pzt:booted';

// Storage pode lançar (modo privado, cookies bloqueados). Nada aqui é essencial,
// então falha silenciosamente para o valor padrão.
const readStorage = (storage, key) => {
  try {
    return window[storage].getItem(key);
  } catch {
    return null;
  }
};

const writeStorage = (storage, key, value) => {
  try {
    window[storage].setItem(key, value);
  } catch {
    /* storage indisponível — segue com o estado só em memória */
  }
};

function App() {
  // Loader só na primeira visita da sessão. sessionStorage (e não localStorage)
  // faz a animação de boot voltar a aparecer numa aba/sessão nova.
  const [loading, setLoading] = useState(
    () => readStorage('sessionStorage', BOOTED_KEY) !== '1'
  );
  const [darkMode, setDarkMode] = useState(() => {
    const saved = readStorage('localStorage', THEME_KEY);
    return saved === null ? true : saved === 'true';
  });
  const [language, setLanguage] = useState(() => {
    const saved = readStorage('localStorage', LANGUAGE_KEY);
    return saved === 'pt' || saved === 'en' ? saved : 'pt';
  });

  useEffect(() => {
    writeStorage('localStorage', THEME_KEY, String(darkMode));
  }, [darkMode]);

  useEffect(() => {
    writeStorage('localStorage', LANGUAGE_KEY, language);
  }, [language]);

  const toggleDarkMode = () => {
    setDarkMode(prev => !prev);
  };

  const toggleLanguage = () => {
    setLanguage(prev => (prev === 'pt' ? 'en' : 'pt'));
  };

  const handleLoaderComplete = () => {
    writeStorage('sessionStorage', BOOTED_KEY, '1');
    setLoading(false);
  };

  if (loading) {
    return <Loader onComplete={handleLoaderComplete} />;
  }

  return (
    <div className={`App ${darkMode ? 'dark' : 'light'}`}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={
            <Portfolio 
              darkMode={darkMode} 
              toggleDarkMode={toggleDarkMode}
              language={language}
              toggleLanguage={toggleLanguage}
            />
          } />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;